export default __webpack_public_path__ + "static/boge-schraubenkompressor-_c-22-2_produkt-f6e994c7b6b4a1c281deacccb6d9cece.png";